const images = {
  icUser: require('../styles/image/icon_user.png'),
  icDelete: require('../styles/image/delete_icon.png'),
  icPlus: require('../styles/image/plus.png'),
  icCalendar: require('../styles/image/calendar.png'),
  icUPMove: require('../styles/image/up_icon.png'),
  icDownMove: require('../styles/image/down_icon.png'),
  icGuide: require('../styles/image/icon_guide.png'),
};

export default images;
